export const SupervisionType = {
    0: null, 
    1: 'state',
    2: 'stateReligious',
    3: 'religious',
};


